import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FilterListService } from 'gung-list';

@Injectable({
  providedIn: 'root'
})
export class CarLinerFilterListService<T> extends FilterListService<T> {
  enableSaveSearch = true;

  constructor(protected route: ActivatedRoute) {
    super(route);
  }
}
